import { http } from "@/lib/api";

// Export "All records": walk the server pages with the CURRENT filters applied.
export async function fetchAllPages(path, qs) {
  const p = new URLSearchParams(qs);
  p.delete("limit");
  p.delete("offset");
  const base = p.toString();
  const out = [];
  for (let off = 0; ; off += 1000) {
    const { data } = await http.get(`${path}?${base}&limit=1000&offset=${off}`);
    const items = data.items || [];
    out.push(...items);
    if (items.length < 1000 || out.length >= (data.total || 0) || out.length >= 100000) break;
  }
  return out;
}
